// Intl-based date/time formatting for Dashboard V2. Kept dependency-free (no
// `@/util/date`, which transitively pulls in app chrome) and timezone-aware.

const DEFAULT_TZ = 'America/New_York';

const time = (iso: string, tz: string): string =>
  new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })
    .format(new Date(iso))
    .replace(/\s/g, '')
    .toUpperCase();

const monthDay = (iso: string, tz: string): string =>
  new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    month: 'short',
    day: 'numeric',
  }).format(new Date(iso));

// "Jun 18, 6:00PM-12:00AM"
export const formatShiftDateTime = (
  startIso?: string | null,
  endIso?: string | null,
  tz?: string | null,
): string => {
  if (!startIso) return '';
  const zone = tz || DEFAULT_TZ;
  const date = monthDay(startIso, zone);
  const start = time(startIso, zone);
  const end = endIso ? time(endIso, zone) : '';
  return end ? `${date}, ${start}-${end}` : `${date}, ${start}`;
};

// "09:00" (24h) or "--:--" when no check-in/out was captured.
export const formatClock = (
  iso?: string | null,
  tz?: string | null,
): string => {
  if (!iso) return '--:--';
  return new Intl.DateTimeFormat('en-US', {
    timeZone: tz || DEFAULT_TZ,
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).format(new Date(iso));
};

// Break / Total durations: "H:MM" or "--" when unset.
export const formatDuration = (minutes?: number | null): string => {
  if (minutes == null) return '--';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${h}:${String(m).padStart(2, '0')}`;
};

// "Jun 16, 5:30 AM"
export const formatMarkedAt = (
  iso?: string | null,
  tz?: string | null,
): string => {
  if (!iso) return '';
  const zone = tz || DEFAULT_TZ;
  const t = new Intl.DateTimeFormat('en-US', {
    timeZone: zone,
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(new Date(iso));
  return `${monthDay(iso, zone)}, ${t}`;
};
